import React from "react";

// Last line of defence: any render error shows a message instead of a blank page.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#0b0f19", color: "#e2e8f0", fontFamily: "system-ui, sans-serif" }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <h1 style={{ fontSize: 22, marginBottom: 8 }}>Si è verificato un errore</h1>
          <p style={{ color: "#94a3b8", marginBottom: 16 }}>
            La pagina non è stata caricata correttamente. Ricarica per riprovare.
          </p>
          <p style={{ color: "#64748b", fontSize: 12, marginBottom: 20, wordBreak: "break-word" }}>{String(this.state.error?.message || this.state.error)}</p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: "#22d3ee", color: "#0b0f19", fontWeight: 600, cursor: "pointer" }}
          >
            Ricarica la pagina
          </button>
        </div>
      </div>
    );
  }
}
